export enum SortDirection {
    Unred = 0,
    New = 1,
    Old = 2
}